import React from 'react'

import './tips-redeem-item.scss';

const TipsRedeemItem = props => {
    return (
        <li className="f-tips-item">
            {!props.mobile &&
                <img className="f-tips-item-image" src={props.imgUrl} alt="" />}
            <div className="f-tips-item-info">
                <p className="f-tips-item-info-description">
                    {props.description}
                </p>
            </div>
        </li>
    )
}

export default TipsRedeemItem;
